import React, { useEffect, useRef, useState } from 'react';
import './FranchiseLocations.css';
import mapImage from '../../Franchise_Page_Images/4-Franchise-map-02.png';
import storeImage from '../../Franchise_Page_Images/5-Franchise-our-locations-01.png';

// Simple state lists for the new layout
const operationalStates = ['NEW JERSEY', 'RHODE ISLAND', 'CONNECTICUT', 'MARYLAND', 'VERMONT'];
const comingSoonStates = ['NEW YORK', 'DELAWARE', 'FLORIDA'];

const FranchiseLocations: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const statesRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsVisible(true);
            }, 100);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );

    if (statesRef.current) {
      observer.observe(statesRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="franchise-locations">
      <div className="franchise-locations__content">
        <h2 className="franchise-locations__title">OUR LOCATIONS</h2>
        <div className="franchise-locations__divider" />

        <p className="franchise-locations__description">
          We are the fastest growing cannabis dispensary franchise company on the East Coast.
        </p>

        <div className="franchise-locations__grid">
          {/* Two-column state list */}
          <div
            ref={statesRef}
            className={`franchise-locations__states${isVisible ? ' franchise-locations__states--visible' : ''}`}
          >
            <div className="franchise-locations__column">
              <div className="franchise-locations__column-header">
                <span className="franchise-locations__dot franchise-locations__dot--operational" />
                <span>In Operation</span>
              </div>
              <ul className="franchise-locations__state-list">
                {operationalStates.map(state => <li key={state}>{state}</li>)}
              </ul>
            </div>

            <div className="franchise-locations__column">
              <div className="franchise-locations__column-header">
                <span className="franchise-locations__dot franchise-locations__dot--coming-soon" />
                <span>Coming Soon</span>
              </div>
              <ul className="franchise-locations__state-list">
                {comingSoonStates.map(state => <li key={state}>{state}</li>)}
              </ul>
            </div>
          </div>

          {/* Map image */}
          <div className="franchise-locations__map-container">
            <img
              src={mapImage}
              alt="East Coast Locations Map"
              className="franchise-locations__map"
            />
          </div>
        </div>

        {/* Store image */}
        <div className="franchise-locations__store-container">
          <img
            src={storeImage}
            alt="Sweetspot Store Interior"
            className="franchise-locations__store-image"
          />
          <div className="franchise-locations__store-nav">
            <span className="franchise-locations__store-name">River Edge, NJ</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FranchiseLocations;
